import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";

class tagForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-10">
                        <TextInput name="tagname" value={this.props.values.tagname} label="Megnevezés" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("tagname")}/>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(tagForm);
